const pointsBadgePath = "/asset/points/badge/";
export const POINTS_BADGES = {
    _FALLBACK: pointsBadgePath + "fallback-badge.svg",
    EMERALD: pointsBadgePath + "emerald.svg",
    SAPPHIRE: pointsBadgePath + "sapphire.svg",
    RUBY: pointsBadgePath + "ruby.svg",
    DIAMOND: pointsBadgePath + "diamond.svg",
    OPAL: pointsBadgePath + "opal.svg",
} as const;
